var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('ejs-diagram',{attrs:{"id":"diagram","width":_vm.width,"height":_vm.height,"nodes":_vm.nodes,"snapSettings":_vm.snapSettings,"layout":_vm.layout}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }